const Membersjson = [
    {
        ID: 1, 
        name: "Akindele Tunde"
    },
    {
        ID: 2, 
        name: "Segun Taiwo"
    },
    {
        ID: 3, 
        name: "Awosope Damilola"
    },
    {
        ID: 4, 
        name: "Bolaji Oladipo"
    },
    {
        ID: 5, 
        name: "Odebunmi Timothy"
    }
]

export default Membersjson